module.exports = __webpack_public_path__ + "static/media/programmer.349b6a3e.jpg";